import { createContext, useContext, useMemo } from 'react';
import { AxiosError } from 'axios';

type DefaultErrorHandlersContextType = {
  defaultAxiosErrorHandler: (error: AxiosError) => Promise<boolean>;
};

const DefaultErrorHandlersContext =
  createContext<DefaultErrorHandlersContextType>({
    defaultAxiosErrorHandler: async () => false,
  });

export const DefaultErrorHandlersProvider = ({
  defaultAxiosErrorHandler,
  children,
}: {
  defaultAxiosErrorHandler: (error: AxiosError) => Promise<boolean>;
  children: React.ReactNode;
}) => {
  const value = useMemo(
    () => ({
      defaultAxiosErrorHandler,
    }),
    [defaultAxiosErrorHandler],
  );

  return (
    <DefaultErrorHandlersContext.Provider value={value}>
      {children}
    </DefaultErrorHandlersContext.Provider>
  );
};

export const useDefaultErrorHandlers = () => {
  return useContext(DefaultErrorHandlersContext);
};
